<form class="form-body pb-0" [formGroup]="passwordForm">
    <div class="grid">
        <div class="col-12">
            <div class="form-group flex flex-column w-full">
                <label>Old Password</label>
                <p-password
                formControlName="old_password"
                [feedback]="false"
                [toggleMask]="true"
                ></p-password>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group flex flex-column w-full">
                <label>New Password</label>
                <p-password
                formControlName="new_password"
                [toggleMask]="true"
                [(ngModel)]="passwordStrenth"
                >
                </p-password>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group flex flex-column w-full">
                <label>Confirm New Password</label>
                <p-password
                formControlName="confirm_password"
                [feedback]="false"
                ></p-password>
            </div>
        </div>
    </div>
  </form>

<div class="form-action flex justify-content-center">
    <p-button
        label="Cancel"
        [outlined]="true"
        severity="secondary"
        (onClick)="onCancel()"
    ></p-button>
    <p-button
        label="Update"
        icon="pi pi-check"
        styleClass="brown-btn"
        iconPos="left"
        severity="primary"
        [style]="{ 'margin-left': '.8em' }"
        (click)="onUpdate()"
        [disabled]="!passwordForm.valid"
    ></p-button>
</div>